export default function getDayName(date = new Date()){
    const days = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    let day = date.getDay()
    day = days[day]
    return day
}